import { useState } from 'react';
import Chip from '@mui/material/Chip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import { ShortlistItemStatus, SHORTLIST_ITEM_STATUS } from '@karehero/models';
import { Stack, Typography } from '@mui/material';
import { Icon } from '@/components/atoms/Icon';

const STATUS_CONFIG: {
  value: ShortlistItemStatus;
  label: string;
  color: 'default' | 'info' | 'success' | 'error';
}[] = [
  {
    value: SHORTLIST_ITEM_STATUS.NOT_CONTACTED,
    label: 'Not contacted',
    color: 'default',
  },
  {
    value: SHORTLIST_ITEM_STATUS.CONTACTED,
    label: 'Contacted',
    color: 'info',
  },
  {
    value: SHORTLIST_ITEM_STATUS.SECURED,
    label: 'Secured',
    color: 'success',
  },
  {
    value: SHORTLIST_ITEM_STATUS.UNAVAILABLE,
    label: 'Unavailable',
    color: 'error',
  },
];

interface StatusChipProps {
  status: ShortlistItemStatus;
  onStatusChange: (status: ShortlistItemStatus) => void;
  onDismiss: () => void;
}

export const StatusChip = ({
  status,
  onStatusChange,
  onDismiss,
}: StatusChipProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const config =
    STATUS_CONFIG.find((c) => c.value === status) ?? STATUS_CONFIG[0];

  return (
    <>
      <Chip
        label={
          <Stack
            direction='row'
            spacing={1}
            sx={{
              alignItems: 'center',
            }}
          >
            <Typography variant='body2'>{config.label}</Typography>
            <Icon icon='chevron-down' />
          </Stack>
        }
        color={config.color}
        size='small'
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
        sx={{ cursor: 'pointer' }}
      />
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        {STATUS_CONFIG.map((opt) => (
          <MenuItem
            key={opt.value}
            selected={opt.value === status}
            onClick={(e) => {
              e.stopPropagation();
              setAnchorEl(null);
              onStatusChange(opt.value);
            }}
          >
            {opt.label}
          </MenuItem>
        ))}
        <Divider />
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            setAnchorEl(null);
            onDismiss();
          }}
          sx={{ color: 'error.main' }}
        >
          Dismiss
        </MenuItem>
      </Menu>
    </>
  );
};
